import React from "react";
import * as classNames from "classnames";
import styles from "./button.css";

// Buttons

const Button = ({
	onClick,
	children,
	className,
	type,
	disabled = false,
	style
}) => {
	const allClassNames = classNames(styles.button, style, className);

	return (
		<button
			className={allClassNames}
			onClick={onClick}
			type={type}
			disabled={disabled}
		>
			{children}
		</button>
	);
};

export const PrimaryButton = props => (
	<Button {...props} style={styles.primary} />
);

export const SecondaryButton = props => (
	<Button {...props} style={styles.secondary} />
);

export const TertiaryButton = props => (
	<Button {...props} style={styles.tertiary} />
);

// Link buttons

const LinkButton = ({ href, children, className, style }) => {
	const allClassNames = classNames(styles.button, style, className);

	return (
		<a href={href} className={allClassNames}>
			{children}
		</a>
	);
};

export const PrimaryLinkButton = props => (
	<LinkButton {...props} style={styles.primary} />
);

export const SecondaryLinkButton = props => (
	<LinkButton {...props} style={styles.secondary} />
);
export const TertiaryLinkButton = props => (
	<LinkButton {...props} style={styles.tertiary} />
);



// WEBPACK FOOTER //
// ./src/components/ui/button/button.js